<template>
  <div class="box_bottom_conten">
    <div class="box_bottom_top">
      <div class="box_bottom">
        <p>联系我们</p>
        <div class="box_dianhua">
          <svg-icon iconClass="dianhua-2" className="dianhua"></svg-icon>
          <span style="padding-left: 10px">86 - 190 6515 7220</span>
        </div>
        <div class="box_dianhua">
          <svg-icon iconClass="dizhi" className="dianhua"></svg-icon>
          <span style="padding-left: 10px"
            >深圳市罗湖区鹏兴路2号鹏基莲塘工业区713栋</span
          >
        </div>
      </div>
    </div>
    <div class="footer-copy">
      <p style="padding-top:20px;">
        Copyright © 2018-2020 周六福 All rights reserved.
        <a href="http://beian.miit.gov.cn/" target="_blank" style="color:white;"
          >粤ICP备13087551号</a
        >
      </p>
      <div style=" padding:20px 0;">
        <a
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030302001449"
          style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"
          ><img src="../assets/img/record.png" style="float:left;" />
          <p
            style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;"
          >
            粤公网安备 44030302001449号
          </p>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {}
</script>

<style scoped lang="scss">
.box_dianhua {
  font-size: 16px;
  margin-top: 20px;
  color: #999;
}
.dianhua {
  width: 20px;
  height: 20px;
}
.box_bottom {
  padding: 20px;
  font-size: 24px;
  color: #fff;
}
.box_bottom_top {
  max-width: 1500px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.box_bottom_conten {
  width: 100%;
  background-color: #212529;
}
.footer-copy {
  border-top: 1px solid #5c5c5c;
  text-align: center;
}
.footer-copy > p {
  color: #7e7e7e;
  font-size: 14px;
  margin: 0;
  width: 100%;
  text-align: center;
  /* margin-top: 80px; */
}
.footer-copy p a {
  color: #007bff;
  text-decoration: none;
  background-color: transparent;
  -webkit-text-decoration-skip: objects;
}
</style>
